import {
  Component,
  inject,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { suggestionDTO } from '@capiche/ts-data-models-shared';

import { CapicheMaterialModule } from 'capiche-material';
import { CapicheLoggerService } from 'capiche-logger';
import { DisclosurePathService, DisclosurePath } from 'capiche-disclosure-path';

import { DisclosureControlsComponent } from '../disclosure-controls/disclosure-controls.component';
import { ComponentInstanceTracker } from '../../utils/component-instance-tracker';

@Component({
  selector: 'app-suggestion',
  standalone: true,
  imports: [CommonModule, CapicheMaterialModule, DisclosureControlsComponent],
  templateUrl: './suggestion.component.html',
  styleUrls: ['./suggestion.component.css'],
})
export class SuggestionComponent implements OnInit, OnChanges, OnDestroy {
  private disclosurePathService = inject(DisclosurePathService);
  private logger = new CapicheLoggerService('suggestion.component:', false);

  @Input({ required: true }) suggestion!: suggestionDTO;
  @Input({ required: true }) thisItemPath!: DisclosurePath;

  /** Emit to parent (WordComponent) when user requests a replacement */
  @Output() requestReplace = new EventEmitter<{ path: DisclosurePath; suggestion: suggestionDTO }>();

  get panelOpenState(): boolean {
    return this.disclosurePathService.isCurrent(this.thisItemPath);
  }

  constructor() {
    this.logger.log('constructor');
    ComponentInstanceTracker.increment('SuggestionComponent');
  }

  ngOnInit(): void {
    this.logger.log('ngOnInit', this.suggestion);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['suggestion']) {
      // no-op for now
    }
  }

  ngOnDestroy(): void {
    this.logger.log('ngOnDestroy');
    ComponentInstanceTracker.decrement('SuggestionComponent');
  }

  // return true if component should be displayed
  get showComponent(): boolean {
    return true;
  }

  onOpened() {
    this.disclosurePathService.setCurrent(this.thisItemPath);
  }

  onClosed() {
    // Only clear if this is *still* current path
    if (this.disclosurePathService.isCurrent(this.thisItemPath)) {
      this.disclosurePathService.setCurrent({
        ...this.thisItemPath,
        suggestionIndex: null,
      });
    }
  }

  scrollToExpanded() {
    this.logger.log('scrollToExpanded:', this.thisItemPath, this.suggestion.word);
  }

  onDoubleClickPanel(event: Event) {
    event.stopPropagation();
    this.logger.log('onDoubleClickPanel:', this.thisItemPath, this.suggestion);
    this.onMakeReplacement(this.thisItemPath);
  }

  /** Forward replacement up to parent word */
  onMakeReplacement(path: DisclosurePath) {
    this.logger.log('suggestion → emit replacement:', this.suggestion, path);
    this.requestReplace.emit({ path, suggestion: this.suggestion });
  }

  trackByFn(index: number, item: suggestionDTO): number {
    return index;
  }
}
